<template>
  <div class="container">
    <div class="head-wrap">
      <i class="el-icon-arrow-left btn" @click="getPrevMonth"></i>
      <p class="text">{{ calendar.year }}年 - {{ calendar.month }}月</p>
      <i class="el-icon-arrow-right btn" @click="getNextMonth"></i>
    </div>
    <div class="week-wrap">
      <span>日</span>
      <span>一</span>
      <span>二</span>
      <span>三</span>
      <span>四</span>
      <span>五</span>
      <span>六</span>
    </div>
    <div class="dates-wrap">
      <div
        class="row"
        v-for="(item, itemIndex) in calendar.dayList"
        :key="itemIndex"
      >
        <div
          class="date"
          :class="{ today: key.date === today, conflict: key.conflict }"
          v-for="(key, index) in item"
          :key="key.date"
        >
          <span v-if="key.disable" class="grey">{{ key.day }}</span>
          <span
            v-else
            :class="{
              selected: key.selected,
            }"
            @click="selectDay(itemIndex, index, key.date)"
            >{{ key.day }}</span
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { arrangedDateListApi } from "@/api/lesson";
import { dateFormat } from "@/utils/timeFormat";

export default {
  // @Prop({ default: () => [] }) days!: string[];
  // @Prop() classId!: string;
  props: ["days", "classId"],
  data() {
    return {
      selectedList: this.days,
      calLoading: false,
      calendar: {
        dayList: [],
        prev: [],
        current: [],
        next: [],
        year: "",
        month: "",
        weeks: ["一", "二", "三", "四", "五"],
        isDay: "",
      },
      today: "",
    };
  },
  mounted() {
    this.backToday();
  },

  created() {
    this.today = dateFormat("YYYY-mm-dd", new Date());
    // console.log(this.today);
  },
  methods: {
    selectDay(i, j, date) {
      const index = this.selectedList.findIndex((v, i, a) => {
        return date === v;
      });
      const ori = this.selectedList;
      if (index >= 0) {
        this.calendar.dayList[i][j].selected = false;
        ori.splice(index, 1);
      } else {
        this.calendar.dayList[i][j].selected = true;
        ori.push(date);
      }
      this.selectedList = ori;
      this.$emit("update:days", ori);
    },
    initDate(val) {
      if (val < 10) {
        return "0" + val;
      } else {
        return val;
      }
    },
    getLastDate(year, month) {
      return new Date(year, month, 0);
    },
    getmonthDays() {
      const that = this;
      const y = that.calendar.year;
      const m = that.calendar.month;
      let preYear;
      let preMonth;
      let nextYear;
      let nextMonth;
      that.calendar.current = [];
      that.calendar.prev = [];
      that.calendar.next = [];
      for (let i = 1; i <= that.getLastDate(y, m).getDate(); i++) {
        const date = y + "-" + m + "-" + that.initDate(i);
        that.calendar.current.push({
          date: date,
          day: i,
          timeList: [],
          disable: false,
          selected: this.selectedList.includes(date),
          conflict: false,
        });
      }
      const d = that.getLastDate(y, m - 1).getDate();
      preYear = m == 1 ? y - 1 : y;
      preMonth = m == 1 ? 12 : that.initDate(parseInt(m) - 1);
      for (let j = that.getLastDate(y, m - 1).getDay(); j >= 0; j--) {
        const date = preYear + "-" + preMonth + "-" + (d - j);
        that.calendar.prev.push({
          date: date,
          day: d - j,
          timeList: [],
          disable: true,
          selected: this.selectedList.includes(date),
          conflict: false,
        });
      }
      nextYear = m == 12 ? y + 1 : y;
      nextMonth = m == 12 ? "01" : that.initDate(parseInt(m) + 1);
      for (
        let k = 1;
        k <= 42 - that.calendar.current.length - that.calendar.prev.length;
        k++
      ) {
        const date = nextYear + "-" + nextMonth + "-" + that.initDate(k);
        that.calendar.next.push({
          date: date,
          day: k,
          timeList: [],
          disable: true,
          selected: this.selectedList.includes(date),
          conflict: false,
        });
      }
      that.calendar.dayList = [];
      const tempArr = that.calendar.prev.concat(
        that.calendar.current,
        that.calendar.next
      );
      // 标记冲突
      arrangedDateListApi({
        class_id: Number(this.classId),
        start_date: tempArr[0].date,
        end_date: tempArr[tempArr.length - 1].date,
      }).then((res) => {
        tempArr.map((date) => {
          date.conflict = res.data.list.indexOf(date.date) >= 0;
        });
      });
      // 分行
      for (let i = 0; i < tempArr.length; i += 7) {
        that.calendar.dayList.push(tempArr.slice(i, i + 7));
      }
    },
    getPrevMonth() {
      if (this.calendar.month != 1) {
        this.calendar.month = this.initDate(--this.calendar.month);
      } else {
        this.calendar.month = 12;
        this.calendar.year = --this.calendar.year;
      }
      this.getmonthDays();
      this.currentDay();
      this.$emit("on-click", 0);
    },
    getNextMonth() {
      if (this.calendar.month < 12) {
        this.calendar.month = this.initDate(++this.calendar.month);
      } else {
        this.calendar.month = "01";
        this.calendar.year = ++this.calendar.year;
      }
      this.getmonthDays();
      this.currentDay();
      this.$emit("on-click", 1);
    },
    currentDay() {
      const that = this;
      const date = new Date();
      const y = that.calendar.year;
      const m = that.calendar.month;
      if (y === date.getFullYear() && m == date.getMonth() + 1) {
        that.calendar.isDay = y + "-" + m + "-" + that.initDate(date.getDate());
      } else {
        that.calendar.isDay = -1;
      }
    },
    backToday() {
      const that = this;
      const d = new Date();
      that.calendar.year = d.getFullYear();
      that.calendar.month = that.initDate(d.getMonth() + 1);
      that.currentDay();
      that.getmonthDays();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  font-size: 12px;
  color: #6e7073;
  padding: 12px;
  box-shadow: 0px 0px 10px 0px rgba(203, 203, 203, 0.5);
}
.head-wrap {
  text-align: center;
  display: flex;
  line-height: 28px;
  .btn {
    line-height: 28px;
    padding: 0 12px;
    cursor: pointer;
  }
  .text {
    flex: 1;
  }
}
.week-wrap {
  text-align: center;
  display: flex;
  margin: 0 0 12px 0;
  line-height: 30px;
  border-bottom: 1px solid #e7e8ea;
  span {
    text-align: center;
    flex: 1;
  }
}
.dates-wrap {
  text-align: center;
  .row {
    display: flex;
    margin: 8px 0;
    .date {
      flex: 1;
      position: relative;
      &.conflict {
        &::after {
          content: "";
          width: 4px;
          height: 4px;
          border-radius: 50%;
          background-color: #f56c6c;
          position: absolute;
          bottom: -5px;
          left: 14px;
        }
      }
      &.today {
        color: #38dabb;
      }
      span {
        display: inline-block;
        width: 24px;
        height: 24px;
        line-height: 24px;
        text-align: center;
        border-radius: 50%;
        cursor: pointer;
        &:hover {
          color: #ffffff !important;
          background-color: #38dabb !important;
        }
        &.selected {
          color: #ffffff !important;
          background-color: #38dabb !important;
        }
        &.grey {
          color: #c2c3c4 !important;
          background-color: #ffffff !important;
        }
      }
    }
  }
}
</style>
